var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_855_4433)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_855_4433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19453 0.875V3.325M9.09453 0.875V3.325M0.519531 5.775H12.7695M10.3195 2.1H2.96953C2.31975 2.1 1.69658 2.35812 1.23712 2.81759C0.777655 3.27705 0.519531 3.90022 0.519531 4.55V10.675C0.519531 11.3248 0.777655 11.9479 1.23712 12.4074C1.69658 12.8669 2.31975 13.125 2.96953 13.125H10.3195C10.9693 13.125 11.5925 12.8669 12.0519 12.4074C12.5114 11.9479 12.7695 11.3248 12.7695 10.675V4.55C12.7695 3.90022 12.5114 3.27705 12.0519 2.81759C11.5925 2.35812 10.9693 2.1 10.3195 2.1Z",
    stroke: "#667085",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_855_4433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3,
    height: 14,
    fill: "white",
    transform: "translate(-0.00195312)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_855_4433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3,
    height: 14,
    fill: "white",
    transform: "translate(-0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/Datepicker.a5579f01d090f3e987e8aa281aa374a0.svg";
export { ForwardRef as ReactComponent };